import { get, post, put, del } from "../../data/api";
export async function getExpenses(toolPublicId) {
    return await get('expense/' + toolPublicId)
}


export async function createExpense(params, toolId) {
    let exp = {
        PublicToolId: toolId,
        Description: params.description,
        TotalPrice: params.totalPrice,
        PurchaseDate: toDateOnly(new Date(params.purchaseDate))
    };

    return await post(exp, 'expense')
}

// Jour choisi sans fuseau : en JSON, minuit à Paris devenait la veille à 22 h/23 h UTC.
function toDateOnly(value) {
    const date = isNaN(value) ? new Date() : value;
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
}

export async function updateExpense(params, publicId) {
    let exp = {
        Description: params.description,
        TotalPrice: params.totalPrice 
    };

    return await put(exp, 'expense/' + publicId)
}

export async function deleteExpense(publicId) {
    return await del('expense/' + publicId)
}